import styleInject from '../../node_modules/style-inject/dist/style-inject.es.js';

var css_248z = ".card-library--LzN-3 {\n  padding: 1.6rem;\n  margin-bottom: 0.8rem;\n  background: #fff;\n  border-radius: 0.3rem;\n  box-shadow: 0 1px 3px 0 rgba(41, 41, 41, 0.2);\n}";
var styles = {"card":"card-library--LzN-3"};
styleInject(css_248z);

export { styles as default };
